module.exports = __webpack_public_path__ + "media/durango/bruno_20-38fae2b7.jpg";